module.exports = __webpack_public_path__ + "static/media/kg.e8f22dc3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kg.svg
// module id = 2128
// module chunks = 0